<template>
  <span class="whitespace-nowrap">
    <Tooltip width="300" placement="top">
      <template #trigger>
        <div class="d-flex align-items-center">
          <span class="title">{{ status }}</span
          >: {{ statusCount }}
          <i class="fa-regular ml-1" :class="iconClass" />
        </div>
      </template>
      <template #tooltip>
        <div class="text-center">
          {{ tooltipText }}
        </div>
      </template>
    </Tooltip>
  </span>
</template>

<script setup lang="ts">
import { computed } from "vue";

import Tooltip from "@/components/Tooltip.vue";

const props = defineProps({
  status: {
    type: String,
    required: true
  },
  statusCount: {
    type: Number,
    required: true
  }
});

const iconClass = computed(() => {
  switch (props.status) {
    case "pending":
      return ["pending", "fa-exclamation-triangle"];
    case "verified":
      return ["verified", "fa-check-circle"];
    case "inactive":
      return ["inactive", "fa-circle-minus"];
  }

  return [props.status];
});

const tooltipText = computed(() => {
  switch (props.status) {
    case "pending":
      return (
        "Pending accounting classes have not been verified with QuickBooks. " +
        "Before an invoice can be sent to QuickBooks, the accounting class(es) used must be verified."
      );
    case "verified":
      return "Verified accounting classes are verified to be present in QuickBooks and are ready for use.";
    case "inactive":
      return (
        "Inactive accounting classes are verified with QuickBooks, but have been inactivated in QuickBooks " +
        "and can not be used when sending an invoice to QuickBooks unless they are made active."
      );
  }

  return null;
});
</script>

<style scoped lang="scss">
.title {
  text-transform: capitalize;
}

.pending {
  color: var(--sera-color-accents-yellow-900);
}

.verified {
  color: var(--sera-color-accents-green-600);
}

.inactive {
  color: var(--sera-color-neutral-gray-med-gray-600);
}
</style>
